export default {
  root: {
    "&:focus, &.Mui-focusVisible": {
      outline: "#DFDFDF solid 3px"
    }
  }
};
